<div class="card card-default mt-3 criteria-box">
  <div class="card-body mx-auto">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>ช่องทางการติดต่อ</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criChannel">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let c of caseChannelList" [value]="c.dpa_casechannelid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>SLA</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criSLA">
                <option value="">กรุณาเลือก</option>
                <option value="false">In SLA</option>
                <option value="true">Over SLA</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>ประเภทรายงานการติดต่อ</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criCaseType" (change)="onCaseTypeChange()">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>ระดับความสำคัญ</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criPriority">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let c of caseSeverityList" [value]="c.dpa_caseseverityid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>หัวข้อการติดต่อ</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criCaseSubType">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let c of caseSubTypeList" [value]="c.dpa_casesubtypeid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="row" *ngIf="role.dpa_report_forsupervisor">
            <div class="col-4">
              <label>ผู้สร้าง</label>
            </div>
            <div class="col-8">
              <select class="form-control select2" [(ngModel)]="criCreate">
                <option value="">เลือก</option>
                <option *ngFor="let a of agentList" [value]="a.dpa_customwebuserid">
                  {{a.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <label>สถานะ</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criStatus">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="row" *ngIf="role.dpa_report_forsupervisor">
            <div class="col-4">
              <label>ผู้แก้ไข</label>
            </div>
            <div class="col-8">
              <select class="form-control select2" [(ngModel)]="criModify">
                <option value="">เลือก</option>
                <option *ngFor="let a of agentList" [value]="a.dpa_customwebuserid">
                  {{a.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <div class="row" *ngIf="role.dpa_report_forsupervisor">
            <div class="col-4">
              <label>Team</label>
            </div>
            <div class="col-8">
              <select class="form-control" [(ngModel)]="criCallcenterteam">
                <option selected value="">กรุณาเลือก</option>
                <option *ngFor="let t of teamList" [value]="t.dpa_callcenterteamid">
                  {{t.dpa_name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <fieldset>
            <legend>วันที่สร้าง:</legend>
            <div class="row">
              <div class="col-6">
                <div class="form-group input-group">
                  <label>จาก</label>
                  <input type="text" class="form-control ml-3" data-provide="datepicker" data-date-language="th-th"  #criFromCreateDate />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group input-group">
                  <label>ถึง</label>
                  <input type="text" class="form-control ml-3" data-provide="datepicker" data-date-language="th-th" #criToCreateDate />
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="col-6">
          <fieldset>
            <legend>วันที่แก้ไขล่าสุด:</legend>
            <div class="row">
              <div class="col-6">
                <div class="form-group input-group">
                  <label>จาก</label>
                  <input type="text" class="form-control ml-3" data-provide="datepicker" data-date-language="th-th" #criFromModifyDate />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group input-group">
                  <label>ถึง</label>
                  <input type="text" class="form-control ml-3" data-provide="datepicker" data-date-language="th-th"  #criToModifyDate />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 text-center">
          <button class="btn btn-primary mr-3" (click)="view()">
            ค้นหา
            <span class="fa fa-search"></span>
          </button>
          <button class="btn btn-default mr-3" (click)="resetCriteriaForm()">
            ล้างค่า
            <span class="fa fa-times"></span>
          </button><button class="btn btn-success" (click)="exportExcel()">
            Export
            <span class="fa fa-file-excel"></span>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="card card-default mt-3">
  <div class="card-header">
    <div class="row">
      <div class="col-8 my-auto">
        <h3 class="card-title font-cust-blue">Report Call Center</h3>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-4 text-center">
            <span class="dot high"></span>
            <label class="high">{{totalHigh}}</label>
            <br>
            <label class="high">High</label>
          </div>
          <div class="col-4 text-center">
            <span class="dot medium"></span>
            <label class="medium">{{totalMedium}}</label>
            <br>
            <label class="medium">Medium</label>
          </div>
          <div class="col-4 text-center">
            <span class="dot low"></span>
            <label class="low">{{totalLow}}</label>
            <br>
            <label class="low">Low</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body table-responsive">
    <table #tbR id="tbReport" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <!-- <th>Priority</th> -->
          <th>SLA</th>
          <th>Case ID</th>
          <th>ชื่อ</th>
          <th>นามสกุล</th>
          <th>หมายเลขโทรศัพท์</th>
          <th>ช่องทางการติดต่อ</th>
          <th>ประเภทรายงานการติดต่อ</th>
          <th>หัวข้อการติดต่อ</th>
          <th>รายละเอียด</th>
          <th>คำตอบ</th>
          <th>PDPA</th>
          <th>สถานะ</th>
          <th>วันที่สร้าง</th>
          <th>ผู้ที่สร้าง</th>
          <th>วันที่แก้ไขล่าสุด</th>
          <th>ผู้ที่แก้ไข</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of reportList">
          <!-- <td align="center"><span class="{{'dot ' + r.dpa_caseseverityidname | lowercase}}"></span></td> -->
          <td align="center" class="high"><label *ngIf="r.dpa_issla">Over</label></td>
          <td>{{r.ticketnumber}}</td>
          <td>{{r.firstname}}</td>
          <td>{{r.lastname}}</td>
          <td>{{r.telephone1}}</td>
          <td>{{r.dpa_casechannelidname}}</td>
          <td>{{r.dpa_casetypeidname}}</td>
          <td>{{r.dpa_casesubtypeidname}}</td>
          <td>{{r.description}}</td>
          <td>{{r.dpa_resolution}}</td>
          <td>{{r.dpa_pdpa_flag}}</td>
          <td>{{r.dpa_casestatusidname}}</td>
          <td>{{r.createdon | thaidate:'shortWithTime' }}</td>
          <td>{{r.dpa_createdby}}</td>
          <td>{{r.modifiedon | thaidate:'shortWithTime' }}</td>
          <td>{{r.dpa_modifiedby}}</td>
        </tr>

      </tbody>
    </table>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/report/report.component.html